import { Box, Typography, styled } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface TimerDisplayProps {
  phase: 'reading' | 'answering';
  displayTime: number;
  readTimeDuration: number;
}

const ReadTimeContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  background: '#FFFFFF',
  borderRadius: '100px',
  padding: '3px',
  paddingRight: '20px',
  gap: '16px',
  width: 'fit-content',
  border: '1px solid #E8E8E8',
  boxShadow: '0px 1px 2px 0px #0205111A',
  cursor: 'default',
  userSelect: 'none',
  minWidth: '120px',
  justifyContent: 'space-between',
}));

const AnswerTimeContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  background: '#FFFFFF',
  borderRadius: '100px',
  padding: '3px',
  paddingRight: '20px',
  gap: '16px',
  width: 'fit-content',
  border: '1px solid #E8E8E8',
  boxShadow: '0px 1px 2px 0px #0205111A',
  cursor: 'default',
  userSelect: 'none',
  minWidth: '120px',
  justifyContent: 'space-between',
}));

const formatTime = (timeInSeconds: number) => {
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = timeInSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const TimerDisplay = ({ phase, displayTime, readTimeDuration }: TimerDisplayProps) => {
  const TimerComponent = phase === 'reading' ? ReadTimeContainer : AnswerTimeContainer;
  const timerLabel = phase === 'reading' ? 'Read time' : 'Answer time';

  // Ensure displayTime does not go below 0 during reading phase countdown
  const timeToDisplay = phase === 'reading' ? Math.max(0, displayTime) : displayTime;

  return (
    <TimerComponent>
      {phase === 'reading' ? (
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          background: 'linear-gradient(90deg, #31C07D 0%, #3BC3B6 100%)',
          borderRadius: '100px',
          padding: '8px 24px 8px 8px',
          gap: '8px',
          color: '#FFFFFF',
          height: '100%',
        }}>
          <AccessTimeIcon sx={{ color: 'inherit', fontSize: '16px' }}/>
          <Typography variant="body2" sx={{ color: 'white', fontWeight: 600, fontSize: '14px' }}>
            {timerLabel}
          </Typography>
        </Box>
      ) : (
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          background: 'linear-gradient(90deg, #47C5FB 0%, #9747FF 100%)',
          borderRadius: '100px',
          padding: '8px 24px 8px 8px',
          gap: '8px',
          color: '#FFFFFF',
          height: '100%',
        }}>
          <AccessTimeIcon sx={{ color: 'inherit', fontSize: '16px' }}/>
          <Typography variant="body2" sx={{ color: 'inherit', fontWeight: 600, fontSize: '14px' }}>
            {timerLabel}
          </Typography>
        </Box>
      )}
      {phase === 'reading' ? (
        <Typography variant="body2" sx={{ color: '#2E9E6B', fontWeight: 600 }}>
          {formatTime(timeToDisplay)}
        </Typography>
      ) : (
        <>
          <Typography variant="body2" sx={{ color: '#625BE4', fontWeight: 600 }}>
            {formatTime(timeToDisplay)}
          </Typography>
        </>
      )}
    </TimerComponent>
  );
};

export default TimerDisplay; 